import React, {useEffect, useRef, useState} from "react";
import {Link, useHistory} from "react-router-dom";
import CommonTitle from "../components/common-title";
import Banner from "../components/banner";
import OnlineCourse from "./home/online";
import OfflineActive from "./home/offline";
import OfflineTrainings from "./home/offlineTraning";
import About from "./discovery/about";
import Activity from "./discovery/activity";
import News from "./discovery/news";
import FixedTabs from "../components/fixed-tabs";
import tip from '../images/tip.png'
import TelecastsLists from "./home/telecasts";
import useImages from "../routers/useImages";
import RegisterGift from "./home/register-gift";
import UserAds from "../components/ads";
import {useLoading} from "../components/loading/LoadingProvider";
import {useDispatch, useSelector} from "react-redux";
import {State} from "../store/reducer";
import {selectHomeRollInfo, getSubtitles} from "../service";
import {Subtitles, subtitlesAction} from "../store/actions";
import TextLoop from "react-text-loop";

function Home() {
    const session = window.sessionStorage.getItem('home_tab_active')
    const [active, setActive] = useState<number>(session ? Number(session) : 0) // ['首页', '关于我们', '直播预告' ,'社群公告', '热点资讯']
    const {push} = useHistory()
    const images = useImages()
    const tabRef = useRef(null)
    const loading = useLoading()
    const subtitles = useSelector<State, State['subtitles']>(state => state.subtitles)
    const dispatch = useDispatch()
    const [companys,setCompanys] = useState([])
    let array:any =[];

    useEffect(() => {
        if (subtitles.length === 0) {
            loading.showLoading()
            getSubtitles().then(res => {
                loading.hideLoading()
                if (res.code === 1) {
                    dispatch(subtitlesAction(res.data))
                }
            })
        }
    }, [subtitles])
    // useEffect(() => {
    //     selectHomeRollInfo().then( res => {
    //         if(res.msg == 'success'){
    //             const companys = res.page
    //             array =  companys.map((item:any)=>'恭喜 ['+item.nickName+'] 成为BG联盟'+ item.starId)
    //         }
    //         setCompanys(array)
    //     })
    // },[])
    const rollInfo = companys && companys.length > 0 ?<TextLoop  children={companys} ></TextLoop>:''

    return <div className="home">


        <FixedTabs active={active} ref={tabRef} tabs={subtitles.length > 0 ? subtitles.map(o => o.subtitleName) : ['首页', '关于我们', '直播预告' ,'社群公告', '热点资讯']} onChange={(index) => {
            setActive(index)
            window.sessionStorage.setItem('home_tab_active', '' + index)
        }}/>
        <UserAds/>

        <div style={{
            position: 'fixed',
            width:'100%',
            marginTop:'1px',
            color:'#FFF',
            fontWeight:'bold',
            paddingLeft:'5px',
            whiteSpace:'pre',
            background:'#00306e',
            zIndex:1,
            fontSize:'15px',
            opacity:0.7,
            borderRadius:'.1rem'
        }}>
            {rollInfo}
        </div>
        {
            active === 0 && <>
                <Banner/>

                <div className="navs">
                    {
                        images && <>
                            <Link to='/home/certification'>
                                <img src={images?.auth} alt=""/>
                            </Link>
                            <Link to='/home/enterprise'>
                                <img src={images?.service} alt=""/>
                            </Link>
                        </>
                    }

                </div>

                <RegisterGift/>

                <div className="section">
                    <CommonTitle title={"线上学院"}>
                        <Link to={'/course'} className='common-more'>
                            more
                        </Link>
                    </CommonTitle>
                    <OnlineCourse/>
                </div>

                <div className="section" style={{marginTop: '.2rem'}}>
                    <CommonTitle title={"线下课预告"}>
                        <span onClick={() => {
                            window.sessionStorage.setItem('course_tab_active', '1')
                            push('/course')
                        }} className='common-more'>
                            more
                        </span>
                    </CommonTitle>
                    <div className="xx" style={{marginTop: '.2rem'}}>
                        <OfflineTrainings type={'home'}/>
                    </div>
                </div>

                <div className="section" style={{paddingTop: '.5rem'}}>
                    <CommonTitle title={"管家生活Vlog"}/>

                    <div className="online" style={{marginTop: '.2rem'}}>
                        <Link to={`/home/vlog`} className="ke">
                            <div className="img-box">
                                {
                                    images && <div className="img-bg" style={{backgroundImage: `url(${images.blog})`}}/>
                                }

                                {/*<img src={ item.coverUrl } alt=""/>*/}
                            </div>
                            <div className="text">
                                <p className="u">管家生活VLOG 免费观看</p>
                            </div>
                        </Link>
                    </div>
                </div>

                <div className="section" style={{marginTop: '.2rem'}}>
                    <CommonTitle title={"社群公告"}>
                        <span onClick={() => {
                            // @ts-ignore
                            tabRef.current.setActiveTab(3)
                        }} className='common-more'>
                            more
                        </span>
                    </CommonTitle>
                    <OfflineActive/>
                </div>

                <div className="section" style={{marginTop: '.2rem'}}>
                    <CommonTitle title={"全球合作伙伴"}/>
                    <img src={images?.partner} alt=""/>
                </div>

                <div className="tips">
                    <img src={tip} alt=""/>
                </div>
            </>
        }

        {
            active === 1 && <div style={{padding: '.3rem'}}><About/></div>
        }

        {
            active === 2 && <TelecastsLists/>
        }

        {
            active === 3 && <Activity/>
        }

        {
            active === 4 && <News/>
        }

        <div style={{ textAlign:'center',marginTop:'10px',fontSize:'15px' }} >
            <a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备15034694号</a>
        </div>


    </div>
}

export default Home
